import { APIHandler, UnauthedAPIHandler } from "../../base";

export const fetchVersion = () => UnauthedAPIHandler.get("/version");

export const fetchConfig = () => APIHandler.get("/config");

export const patchGreeting = (value: string) =>
    APIHandler.patch("/admin/config/greeting", { greeting: value });

export const patchDescription = (value: string) =>
    APIHandler.patch("/admin/config/description", { description: value });

export const patchSampleQuestions = (samples: string[]) =>
    APIHandler.patch("/admin/config/suggestedQuestions", {
        suggestedQuestions: samples.map(sample => ({ question: sample }))
    });
